<template>
<div>
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <!-- <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/> -->

    <!-- MODAL -->
      <actionmodal ref="mymodalconfirm"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <label :class="bodyclass" >{{body}}</label>
            
            <optionbutton2ids :itemList="zeroLines"  @select="selLineItem" v-if="zeroLineCount>0" />
            <div>
                <smallbutton  @click="CloseWithYes" toplabel="Remove" buttonclass="button buttonsave"/>
                <smallbutton  @click="CloseWithNo" toplabel="Cancel" buttonclass="button buttoncancel"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import optionbutton2ids from '../controls/optionbutton2ids.vue';
 import datamethods from '../../services/datamethods.js'
export default {
    name:'confirm',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        optionbutton2ids
        
    },
    props:{
        title:{
            type:String,
            default:'Remove Meal Swipe'
        },
       
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button buttonprimary"
        },
        isAlert:{
            type:Boolean,
            default:false
        },
        ticketId:{
            type:Number,
            required:true
        }
    },
    data(){
        return{
            responseMessage:'',
            selectedId:0,
            selectedQuantity:1,
            ticket:{ticketId:0,
                lineItems:[]
            },
            zeroLines:[],
            zeroLineCount:0
        }
    },
    mixins:[ datamethods],
    computed:{
        body(){
            if(this.zeroLineCount==0){

                return 'Do you want to remove the $0 item ' + this.zeroDollarLineName + '?'
            }else{
                return 'Please select the $0 item that you want to remove and click Remove.'
            }
        },
        bodyclass(){
            if(this.isAlert){
                return "redlabel"
            }else{return ""}
        },
       
        zeroDollarLineId(){
            let id=null
                this.ticket.lineItems.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let tli=arr[index]
                        if(tli.unitPrice==0){
                            id=tli.id
                        }
                    } 
                return id
        },
        zeroDollarLineName(){
            let name=null
                this.ticket.lineItems.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let tli=arr[index]
                        if(tli.unitPrice==0){
                            name=tli.productName
                        }
                    } 
                return name
        }
    },
    methods:{
        Show(){
            this.getTicket()
            this.$refs.mymodalconfirm.openModal()
        },
        async CloseWithYes(){
            this.$emit('yes',this.selectedId2,this.selectedQuantity)
            this.$refs.mymodalconfirm.closeModal()
        },
        async CloseWithNo(){
            this.$emit('no')
           this.$refs.mymodalconfirm.closeModal()
        },
        selLineItem(id,name, id2, quantity){
            this.selectedId = id
            this.selectedId2=id2
            this.selectedQuantity = quantity
        },
        handleZeroItems(){
       
            let zlines =[]
            let zeros=0
                this.ticket.lineItems.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let tli=arr[index]
                        if(tli.amount==0){
                            zeros=zeros+tli.quantity
                            //add to the list
                            for(let i=0;i<tli.quantity;i++){
                                let zline={id:i, name:tli.productName, id2:tli.id, quantity:tli.quantity}
                                zlines.push(zline)
                            }
                        }
                    } 
                this.zeroLineCount= zeros
                this.zeroLines=zlines

                if(zeros==0){
                    this.selectedId=this.zeroDollarLineId
                   
                }
        },
        async getTicket(){
            let req = {
                ticket:{
                    id:this.ticketId
                }
            }  
            //call api
           // this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'ticket')
            //handle response
        
            if(response.Successful){
                this.ticket=response.ticket

                this.handleZeroItems()
                
            }else{
                this.responseMessage = response.Message
            }
            //this.pleaseWait=false;
        },
           
    }
}
</script>

<style>
.redlabel{
    color:var(--color-red);
}
</style>